import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'reports');
}

export const getBibliographyCSVJsonReport = (state) =>
  getState(state).get('bibliographyCSVJsonReport');
export const getBibliographyReportIsLoading = (state) =>
  getState(state).get('isLoading');
export const getUsersReportIsLoading = (state) =>
  getState(state).get('isLoading');
export const getBibliographyReportError = (state) =>
  getState(state).get('errorMessage');
export const getUsersCountData = (state) => getState(state).get('usersCount');
export const getGraph = (state) => getState(state).get('setGraph');
export const getCompletionStatus = (state) =>
  getState(state).get('completionStatus');
export const getCsvAvailability = (state) =>
  getState(state).get('csvDataAvailably');
export const getAutomaticMasterReportData = (state) =>
  getState(state).get('automaticMasterReportData');
export const getAllMasterUserReportLoading = (state) =>
  getState(state).get('allMasterUserReportLoading');
export const getAutomaticSubscriptionsReport = (state) =>
  getState(state).get('automaticSubscriptionsReport');
export const getAutomaticMasterReportCreationDate = (state) =>
  getState(state).get('automaticMasterReportCreationDate');
export const getCsvDataSubsActive = (state) =>
  getState(state).get('csvDataSubsActive');
export const getAllActiveSubscriptionsReportLoading = (state) =>
  getState(state).get('allActiveSubscriptionsReportLoading');
export const getNumberOfQuestionsEnabledPerRatingExamReportCSVData = (state) =>
  getState(state).get('numberOfQuestionsPerRatingExamReportData');
export const getNumberOfQuestionsEnabledPerRatingExamReportHasMore = (state) =>
  getState(state).get('numberOfQuestionsPerRatingExamReportHasMore');
export const getLastRateToUseNumberOfQuestionsEnabledPerRatingExamReport = (
  state,
) => getState(state).get('nextRateToUse');
export const getOverallUniqueNumberOfQuestionsEnabledPerRatingExamReport = (
  state,
) => getState(state).get('numberOfQuestionsPerRatingExamReportOverallUnique');
export const getAPIErrorNumberOfQuestionsEnabledPerRatingExamReport = (state) =>
  getState(state).get('numberOfQuestionsPerRatingExamReportApiError');
export const getUserSubmittedQuestionsReportCSVJson = (state) =>
  getState(state).get('userSubmittedQuestionsReportCSVJson');
export const getIsUserSubmittedQuestionsReportLoading = (state) =>
  getState(state).get('isUserSubmittedQuestionsReportLoading');
export const getUserSubmittedQuestionsReportError = (state) =>
  getState(state).get('userSubmittedQuestionsReportError');
/* Intercom Active Users Report */
export const getIntercomActiveUsersReport = (state) =>
  getState(state).get('intercomActiveUsersReport');
/* Favorite questions report */
export const getLoadingFavoriteQuestionsReport = (state) =>
  getState(state).get('loadingFavoriteQuestionsReport');
export const getLastFavoriteQuestionsReports = (state) =>
  getState(state).get('lastFavoriteQuestionsReports');
/* Rate questions report */
export const getLastRateQuestionsReports = (state) =>
  getState(state).get('lastRateQuestionsReports');
/* Usage statistics report */
export const getUsageStatisticsReports = (state) =>
  getState(state).get('usageStatisticsReports');
export const getUsageStatisticsReportsIsLoading = (state) =>
  getState(state).get('usageStatisticsReportsIsLoading');
/* Books missing answers report */
export const getBooksMissingAnswersReportData = (state) =>
  getState(state).get('booksMissingAnswersReportData');
export const getBooksMissingAnswersReportState = (state) =>
  getState(state).get('booksMissingAnswersReportState');
/* Audio Report */
export const getAudioReportsData = (state) =>
  getState(state).get('audioReportsData');
export const getAudioReportsState = (state) =>
  getState(state).get('audioReportsState');
/* AudioAbbreviation Report */
export const getAudioAbbreviationReport = (state) =>
  getState(state).get('audioAbbreviationReport');
/* Referred Leads Report */
export const getReferredLeadsReportData = (state) =>
  getState(state).get('referredLeadsReportData');
export const getReferredLeadsReportState = (state) =>
  getState(state).get('referredLeadsReportState');
/* Subscription types report */
export const getSubscriptionTypesReports = (state) =>
  getState(state).get('subscriptionTypesReports');
export const getSubscriptionTypesReportsIsLoading = (state) =>
  getState(state).get('subscriptionTypesReportsIsLoading');
/* Assigned To Writers Report */
export const getAssignedToWritersReportData = (state) =>
  getState(state).get('assignedToWritersReportData');
export const getAssignedToWritersReportState = (state) =>
  getState(state).get('assignedToWritersReportState');
/* Self Promotion Status Report */
export const getSelfPromotionReportData = (state) =>
  getState(state).get('selfPromotionReportData');
export const getSelfPromotionReportState = (state) =>
  getState(state).get('selfPromotionReportState');
